import classNames from "classnames";
import * as React from "react";
import "./ToolbarButton.scss";

export interface IToolbarButton {
    iconClassName: string;
    className?: string;
    disabled?: boolean;
    title?: string;
    iconCharacter?: string;
    onClick: () => void;
}

export const ToolbarButton = ({
    iconClassName,
    onClick,
    className,
    disabled,
    title,
    iconCharacter
}: IToolbarButton): JSX.Element => (
    <div className={classNames("toolbar-button", className)} onClick={onClick} title={title || "poga"}>
        {iconCharacter ? <span className="character">{iconCharacter}</span> : <span className={iconClassName} />}
    </div>
);
